export default __webpack_public_path__ + "media/images/logos/plus-divide-grey-a699031095ddf203a5bea0ca822ab755.svg";